import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Footer from '../components/footer';
import Header from '../components/header';

// :: Contact Us | Adber Infra India Pvt. Ltd. ::
const Contact = () => {
    const handleSubmit = (e) => {
        e.preventDefault();
        // handle form submission logic here
    };

    useEffect(() => {
        document.title = ":: Contact Us | Adber Infra India Pvt. Ltd. ::";
    }, []);

    return (
        <div>
            <Header />
            <section className="inner-page-banner-area gallery">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-8 col-sm-8 col-xs-12">
                            <div className="banner-caption contacttext">
                                <h1 className=""> Contact Us </h1>
                                <p> Getting in touch is easy! </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <div className="breadcrumbs-area">
                <div className="container-fluid">
                    <ol className="breadcrumb">
                        <li><Link to="/">Home</Link></li>
                        <li> Contact Us </li>
                    </ol>
                </div>
            </div>

            <div className="container" id="InternalPageArea">
                <div className="row wow slideInUp animated" data-wow-delay="0.5s" style={{ animationDelay: "0.5s", visibility: "visible", animationName: "slideInUp" }}>
                    <div className="col-md-6 col-sm-12 col-xs-12 contactInfo">
                        <h3> Adber Infra India Pvt. Ltd. </h3>
                        <p><span> <i className="fa fa-map-marker" aria-hidden="true"></i> Address </span>
                            Sr. No. 4/2 Wadachi Wadi, Autadewadi Road, Near Kamal Plastic - Undri, Pune - 411028.
                        </p>

                        <p><span> <i className="fa fa-phone" aria-hidden="true"></i> Mobile No. </span>
                            <a href="tel:7030332900 "> +91 7030332900 </a>  / <a href="tel:7030272900 "> 7030272900 </a>  </p>

                        <p className="email"><span> <i className="fa fa-envelope"></i> Email ID </span>
                            <a href="mailto:hr@adberinfra.co.in"> hr@adberinfra.co.in </a> /
                            <a href="mailto:admin@adberinfra.co.in"> admin@adberinfra.co.in </a>
                        </p>

                        <ul className="socialLinks list-inline">
                            <li className="facebook">
                                <a href="https://www.facebook.com/Adberinfra/" className="fa fa-facebook" alt="facebook" title="Facebook" target="_blank">
                                </a>
                            </li>
                            <li className="twitter">
                                <a href=" " title="Twitter" className="fa fa-twitter" aria-hidden="true"></a>
                            </li>
                            <li className="youtube">
                                <a href=" " title="Youtube" className="fa fa-youtube-play" aria-hidden="true"></a>
                            </li>
                        </ul>
                    </div>
                    <div className="col-md-6 col-sm-12 col-xs-12">
                        <div className="enquiry-form wow zoomIn" data-wow-delay="0.5s" style={{ animationDelay: "0.5s", visibility: "visible", animationName: "zoomIn" }}>
                            <div className="validateContainer">
                                <form action="#" method="post" id="form1" name="form1" onSubmit={handleSubmit}>
                                    <div className="col-md-12 col-sm-12">
                                        <div className="form-group">
                                            <label htmlFor="name">Name*</label>
                                            <div className="validateField">
                                                <input type="text" className="form-control validateAlphaonly" name="name" id="name" placeholder="Name*" required="" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-12 col-sm-12">
                                        <div className="form-group">
                                            <label htmlFor="email">Email ID*</label>
                                            <div className="validateField">
                                                <input type="email" className="form-control validateEmail" name="email" id="email" placeholder="Email ID*" required="" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-12 col-sm-12">
                                        <div className="form-group">
                                            <label htmlFor="mobile">Mobile No.*</label>
                                            <div className="validateField">
                                                <input type="text" className="form-control validateNumber validateMobileNoLimit" name="mobile" id="mobile" placeholder="Mobile No.*" minLength="8" maxLength="10" required="" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-12 col-sm-12">
                                        <div className="form-group">
                                            <label htmlFor="message">Message</label>
                                            <div className="validateField">
                                                <textarea className="form-control" id="message" name="message" rows="4" placeholder="Message"></textarea>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-12 col-sm-12 text-right">
                                        <input type="submit" className="btn btn-default btn-submit checkValidationBtn" value="Submit" />
                                        <input type="reset" className="btn btn-default btn-reset checkValidationBtn" value="Reset" />
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
}


export default Contact;
